import React from "react";
import { ToggleButton, Badge } from "react-bootstrap";
import { ApiHeader, Title, GroupBySwitcher } from "../styles/StyledComponents";

/**
 * Header component for the API Explorer
 * @param {Object} props - Component props
 * @param {Object} props.currentUser - The current user
 * @param {boolean} props.groupByMethod - Whether to group endpoints by method
 * @param {Function} props.setGroupByMethod - Function to set grouping preference
 * @returns {JSX.Element}
 */
const Header = ({ currentUser, groupByMethod, setGroupByMethod }) => {
  return (
    <>
      <ApiHeader>
        <div>
          <Title>
            API Explorer
            <Badge
              bg="dark"
              style={{
                marginLeft: "12px",
                fontSize: "0.65em",
                padding: "0.5em 0.8em",
                fontWeight: "600",
                letterSpacing: "0.5px",
                verticalAlign: "middle",
                borderRadius: "4px",
                backgroundColor: "#2c3e50",
                color: "#fff",
                border: "1px solid #34495e",
                textTransform: "uppercase",
              }}
            >
              Sandbox Only
            </Badge>
          </Title>
          {currentUser && (
            <p className="text-muted small mb-0">
              User: {currentUser.firstName} {currentUser.lastName} (ID: {currentUser.id})
            </p>
          )}
        </div>
      </ApiHeader>

      <GroupBySwitcher>
        <ToggleButton
          type="radio"
          variant={!groupByMethod ? "primary" : "outline-primary"}
          name="group-by"
          value="service"
          checked={!groupByMethod}
          onClick={() => setGroupByMethod(false)}
        >
          Group by Service
        </ToggleButton>
        <ToggleButton
          type="radio"
          variant={groupByMethod ? "primary" : "outline-primary"}
          name="group-by"
          value="method"
          checked={groupByMethod}
          onClick={() => setGroupByMethod(true)}
        >
          Group by Method
        </ToggleButton>
      </GroupBySwitcher>
    </>
  );
};

export default Header;
